import { useState } from "react";
import { Lock, Loader2 } from "lucide-react";
import { toast } from "sonner";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";

export default function LoginDialog({ open, onOpenChange }) {
  const { login } = useAuth();
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!password) return;
    setLoading(true);
    try {
      await login(password);
      toast.success("Angemeldet");
      setPassword("");
      onOpenChange(false);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Falsches Passwort");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm rounded-3xl p-7" data-testid="login-dialog">
        <DialogHeader className="items-start">
          <div className="mb-2 grid h-12 w-12 place-items-center rounded-2xl bg-primary/10 text-primary">
            <Lock size={22} />
          </div>
          <DialogTitle className="font-display text-2xl font-bold text-left">
            Anmelden
          </DialogTitle>
          <DialogDescription className="text-left">
            Gib das Passwort ein, um Objekte anzulegen und zu bearbeiten.
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-3 pt-2">
          <Input
            type="password"
            autoFocus
            placeholder="Passwort"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            data-testid="password-input"
            className="h-12 rounded-xl"
          />
          <Button
            type="submit"
            disabled={loading}
            data-testid="login-submit"
            className="h-12 w-full rounded-xl bg-primary text-white font-semibold hover:bg-primary/90"
          >
            {loading ? <Loader2 className="animate-spin" size={18} /> : "Anmelden"}
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
